var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    transform: "translate(-1023 -4240)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1023 4240)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1022 -4238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.044,7.18H17.122A9.942,9.942,0,0,0,7.18,17.122V29.044a9.942,9.942,0,0,0,9.942,9.942H29.044a9.942,9.942,0,0,0,9.942-9.942V17.122A9.942,9.942,0,0,0,29.044,7.18Zm6.961,21.864a6.97,6.97,0,0,1-6.961,6.961H17.122a6.97,6.97,0,0,1-6.961-6.961V17.122a6.97,6.97,0,0,1,6.961-6.961H29.044a6.97,6.97,0,0,1,6.961,6.961Z",
    transform: "translate(-7.18 -7.18)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.041,16.09a7.951,7.951,0,1,0,7.951,7.951A7.951,7.951,0,0,0,24.041,16.09Zm0,12.922a4.971,4.971,0,1,1,4.971-4.971A4.971,4.971,0,0,1,24.041,29.012Z",
    transform: "translate(-8.139 -8.139)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.062,
    cy: 1.062,
    r: 1.062,
    transform: "translate(23.39 6.292)",
    fill: "#e8eaea"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e8f5149c28c4846f9707d09c8e03cf49.svg";
export { ForwardRef as ReactComponent };